var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("annuaire.file_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.Annuaire
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.details"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.Annuaire.FileName !== "" ||
                            _vm.Annuaire.DateImport !== "" ||
                            _vm.Annuaire.IdAnnuaire !== ""
                              ? _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Annuaire.FileName !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("annuaire.file_name"),
                                                inputValue:
                                                  _vm.Annuaire.FileName,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Annuaire.DateImport !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "annuaire.date_import"
                                                ),
                                                inputValue: _vm.getDateDay(
                                                  _vm.Annuaire.DateImport
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _c("label", { attrs: { id: "" } }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("tracking.file"))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-start align-item-start",
                                          },
                                          [
                                            _c("div", [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.seeJson(
                                                      _vm.Annuaire.IdAnnuaire,
                                                      "annuaire",
                                                      "see"
                                                    )
                                                  },
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.seeJson(
                                                      _vm.Annuaire.IdAnnuaire,
                                                      "annuaire",
                                                      "download"
                                                    )
                                                  },
                                                },
                                              }),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.lines"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.Annuaire.Lines && _vm.Annuaire.Lines.length
                              ? _c("b-table", {
                                  staticClass: "table table-striped",
                                  attrs: {
                                    hover: false,
                                    items: _vm.Annuaire.Lines,
                                    fields: _vm.fields,
                                    selectable: false,
                                    responsive: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(Data)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                data.item.FirstName1 !== "" ||
                                                data.item.LastName1 !== "" ||
                                                data.item.MarriedName1 !== "" ||
                                                data.item.BirthName1 !== ""
                                                  ? _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "annuaire.label_pp_1"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "annuaireTable",
                                                        },
                                                        [
                                                          _c("tbody", [
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.first_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .FirstName1,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .FirstName1
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.last_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .LastName1,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .LastName1
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.birth_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .BirthName1,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .BirthName1
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.married_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .MarriedName1,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .MarriedName1
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.item.FirstName2 !== "" ||
                                                data.item.LastName2 !== "" ||
                                                data.item.MarriedName2 !== "" ||
                                                data.item.BirthName2 !== ""
                                                  ? _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "annuaire.label_pp_2"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "ml-5 annuaireTable",
                                                        },
                                                        [
                                                          _c("tbody", [
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.first_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .FirstName2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .FirstName2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.last_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .LastName2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .LastName2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.birth_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .BirthName2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .BirthName2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.married_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .MarriedName2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .MarriedName2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.item.CompanyName !== "" ||
                                                data.item.Siren !== "" ||
                                                data.item.Siret !== "" ||
                                                data.item.TVAIntracomm !== ""
                                                  ? _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "annuaire.label_pm_1"
                                                            )
                                                          ) + ":"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "ml-5 annuaireTable",
                                                        },
                                                        [
                                                          _c("tbody", [
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.company_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .CompanyName,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .CompanyName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.siren"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .Siren,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .Siren
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.siret"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .Siret,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .Siret
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.tva_intracomm"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .TVAIntracomm,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .TVAIntracomm
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.trading_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .TradingName,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .TradingName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.lei"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .LEI,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .LEI
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.euid"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .EUID,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .EUID
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.item.CompanyName2 !== "" ||
                                                data.item.Siren2 !== "" ||
                                                data.item.Siret2 !== "" ||
                                                data.item.TVAIntracomm2 !== ""
                                                  ? _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "annuaire.label_pm_2"
                                                            )
                                                          ) + ":"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "ml-5 annuaireTable",
                                                        },
                                                        [
                                                          _c("tbody", [
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.company_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .CompanyName2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .CompanyName2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.siren"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .Siren2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .Siren2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.siret"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .Siret2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .Siret2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.tva_intracomm"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .TVAIntracomm2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .TVAIntracomm2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.trading_name"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .TradingName2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .TradingName2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.lei"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .LEI2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .LEI2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "annuaire.euid"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "p-1",
                                                                  attrs: {
                                                                    title:
                                                                      data.item
                                                                        .EUID2,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .EUID2
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(Status)",
                                        fn: function (data) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "annuaire.status_" +
                                                      data.value
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(Active)",
                                        fn: function (data) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "annuaire.active_" +
                                                      data.value
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(DateLastUpdate)",
                                        fn: function (data) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDateDay(
                                                    data.item.DateLastUpdate
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1965773624
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }